import { SyntheticEvent } from 'react';
import { VerticalTabContainer } from 'components/tab/Tab.styles';
import { Col, Nav, NavItem, Row, TabContainer } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { normalizeKey } from 'utils/localeUtils';
import useIsMobileScreen from 'hooks/useIsMobileScreen';
import { Breakpoint, breakpoints } from 'styles/mediaQuery';
import useSidePanel from 'components/sidePanel/useSidePanel';
import { ChannelsTab, channelsTabSidePanelId } from './ChannelsTabs.constants';
import useChannelsActiveTab from './useChannelsActiveTab';
import ChannelsTabsHeader from './ChannelsTabsHeader';

export const ChannelsDefaultRoute = () => {
  return <Navigate to={ChannelsTab.directChannels} replace />;
};

const ChannelsTabs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const activeTab = useChannelsActiveTab();
  const isMobile = useIsMobileScreen(breakpoints[Breakpoint.XS]);
  const { closeSidePanel } = useSidePanel({
    sidePanelId: channelsTabSidePanelId,
  });

  const tabsToRender = Object.values(ChannelsTab);

  const onSelect = (event: SyntheticEvent<TabContainer, Event>) => {
    const tabName = event as unknown as string; // should be fixed by BS5

    navigate(tabName);
  };

  const getTabName = (tabName: string): string => {
    return t(normalizeKey(`pageChannels.tabNames.${tabName}`));
  };

  const channelsTabs = (
    <Nav stacked>
      {tabsToRender.map((tabName: string) => (
        <NavItem
          data-testid={`channels-tab-${tabName}`}
          eventKey={tabName}
          key={tabName}
          onClick={closeSidePanel}
        >
          {getTabName(tabName)}
        </NavItem>
      ))}
    </Nav>
  );

  return (
    <VerticalTabContainer activeKey={activeTab} onSelect={onSelect}>
      <Row>
        <Col sm={2}>{!isMobile && channelsTabs}</Col>
        <Col sm={10}>
          <ChannelsTabsHeader sidePanelContent={channelsTabs} />
          <Outlet />
        </Col>
      </Row>
    </VerticalTabContainer>
  );
};

export default ChannelsTabs;
